export default function formAPIchiefcomplaint({
    chiefcomplaint,
    date,
    appointmentid,
    doctorname,
    specialization,
    appointmentdate,
    appointmentdatetime,
    bookingid,
    iscurrentvisit,
    updatedby,
    updatedbyid,
    updateddate
})
{
  return Object.freeze({
    chiefcomplaint,
    date,
    appointmentid,
    doctorname,
    specialization,
    appointmentdate,
    appointmentdatetime,
    bookingid,
    iscurrentvisit,
    updatedby,
    updatedbyid,
    updateddate
  });
}